/**
 * 알약 탭 — **한 벌을 온 사이트가 쓴다.** 머리 메뉴(top-nav), 아티클 목록의 공개|비공개,
 * 공고 목록의 정렬(최신순|마감임박순|금액순). 켜진 것은 진한 회색 바탕 흰 글자, 꺼진 것은
 * 회색 글자에 hover 초록. 크기는 머리 메뉴 알약과 같다(h-8 · px-3 · text-sm · font-medium).
 */
// 테두리 자리를 항상 잡아 둔다(transparent) — hover 에 테두리가 생겨도 1px 씩 안 흔들린다.
export const PILL_TAB = 'inline-flex h-8 shrink-0 items-center rounded-full border border-transparent px-3 text-sm font-medium transition-colors';
// 켜진 알약은 **진한 회색**(gray-700). 검정이던 것을 2026-09-24 형이 바꿨다 — 머리 메뉴 밑줄(검정)과 층이 갈린다.
export const PILL_TAB_ON = 'bg-gray-700 text-white';
/**
 * 기둥 탭 · 프로그램 종류 탭은 켜진 알약의 바탕을 별도 span 으로 그린다. 링크 자체에는 바탕이 없고
 * `relative isolate` 로 자기 stacking context 를 만들어 `-z-10` 바탕이 글자 뒤에 깔린다.
 * 한때 SPA 가 framer `layoutId` 로 이 span 을 탭 사이로 미끄러뜨렸는데 2026-09-24 형이 뺐다 — 정적이다.
 */
export const PILL_TAB_SLIDING_ON = 'relative isolate text-white';
export const PILL_TAB_HIGHLIGHT = 'absolute inset-0 -z-10 rounded-full bg-gray-700';
// 둘째 줄(프로그램 종류)도 같은 옷이다 — 바탕 없이 hover 에만 테두리, 켜지면 gray-700. 시안 색(남회색 바탕)은 2026-09-24 형이 되돌렸다.
// 꺼진 알약에 마우스를 올리면 흰 바탕 + 연회색 테두리의 알약이 드러나고 글자는 검정.
export const PILL_TAB_OFF = 'text-gray-500 hover:border-gray-200 hover:bg-white hover:text-gray-900';
